var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 21.75H50.75M29 29V36.25M29 43.5H29.0242M16.9167 7.25V12.0833M41.0833 7.25V12.0833M14.9833 50.75H43.0167C45.7236 50.75 47.0772 50.75 48.111 50.2232C49.0204 49.7599 49.7599 49.0204 50.2232 48.111C50.75 47.0772 50.75 45.7236 50.75 43.0167V19.8167C50.75 17.1097 50.75 15.7563 50.2232 14.7224C49.7599 13.8129 49.0204 13.0735 48.111 12.6101C47.0772 12.0833 45.7236 12.0833 43.0167 12.0833H14.9833C12.2764 12.0833 10.9229 12.0833 9.88905 12.6101C8.97958 13.0735 8.24018 13.8129 7.77681 14.7224C7.25 15.7563 7.25 17.1097 7.25 19.8167V43.0167C7.25 45.7236 7.25 47.0772 7.77681 48.111C8.24018 49.0204 8.97958 49.7599 9.88905 50.2232C10.9229 50.75 12.2764 50.75 14.9833 50.75Z",
    stroke: "#70707A",
    strokeWidth: 4.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.227313af8da0d47b0204da456b794532.svg";
export { ForwardRef as ReactComponent };